import { createContext } from 'react';

var ServiceRequestType;
(function (ServiceRequestType) {
    ServiceRequestType["GPS"] = "gps";
    ServiceRequestType["CARGO_INSURANCE"] = "cargoInsurance";
    ServiceRequestType["VEHICLE_INSURANCE"] = "vehicleInsurance";
    ServiceRequestType["BUSINESS_LOAN"] = "businessLoan";
})(ServiceRequestType || (ServiceRequestType = {}));
const DefaultContext = {
    isMobile: true,
    currentLocation: { status: "notRequested" },
    // isPhoneVerified: false,
    profilesViewed: [],
    bulkRequestIds: [],
    isBulkUploadModalOpen: false,
    isProductionEnv: false,
    isMobileScreen: false,
    // numOfContactRqsts: 0,
    isLorryNotAllowedPopupOpen: false,
    toggleIsLorryNotAllowedPopupOpen: () => { },
    joinedOn: ""
};
const AppContext = createContext(DefaultContext);

export { AppContext, DefaultContext, ServiceRequestType };
//# sourceMappingURL=app-context.js.map
